// A single cached JSON blob holding every "Total" display count across Home
// and the list pages — Invites/Candidates/Roles are the same underlying
// org-wide counts on Home and on their respective list pages, so sharing
// one blob means whichever page finishes a full load first primes the
// others too, and there's one place to look when inspecting storage.
//
// Callers are expected to only write once a full load finishes, so whatever
// ends up cached is always a real, complete count, never a partial one.
const CACHE_KEY = "techscore_counts";

export function getCachedCounts() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

// Merges `updates` into whatever's already cached, rather than overwriting
// the whole blob — different pages only ever know their own slice of counts
// (e.g. InviteList only knows "Invites"), so a plain overwrite would wipe
// out counts cached by other pages.
export function setCachedCounts(updates) {
  try {
    const merged = { ...getCachedCounts(), ...updates };
    localStorage.setItem(CACHE_KEY, JSON.stringify(merged));
  } catch {
    // ignore storage errors (private browsing, quota, etc.) — worst case
    // the next visit just falls back to the loading skeleton
  }
}
